export const RETURN_BUTTON_LABEL = 'OK, Return';
